// ============================================
// Harita SEO - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const haritaSeoContent: BlogContent = {
  tableOfContents: [
    { id: "harita-seo-temelleri", title: "Harita SEO Temelleri" },
    { id: "nap-stratejisi", title: "NAP Stratejisi" },
    { id: "citation-building", title: "Citation Building" },
    { id: "yorum-stratejileri", title: "Yorum Stratejileri" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>Harita SEO</strong> temel stratejileri ve optimizasyon teknikleri."
    }
  ]
};

export default haritaSeoContent;
